import { LucideIcon } from "lucide-react";

interface MarketingPageHeaderProps {
  icon: LucideIcon;
  iconColor?: string; 
  title: string;
  description: string;
  actions?: React.ReactNode; 
}

export function MarketingPageHeader({
  icon: Icon,
  iconColor = "bg-blue-500",
  title,
  description,
  actions,
}: MarketingPageHeaderProps) {
  return (
    <div className="bg-gradient-to-r from-slate-50 to-gray-50 dark:from-slate-900/50 dark:to-gray-900/50 border border-slate-200 dark:border-slate-700 rounded-xl p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className={`flex items-center justify-center w-12 h-12 ${iconColor} rounded-lg shadow-sm`}>
            <Icon className="h-6 w-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100">{title}</h2>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
              {description}
            </p>
          </div>
        </div>
        {actions && <div>{actions}</div>}
      </div>
    </div>
  );
}

